//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale'
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClientBase {
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface ILogClient {
    /**
     * @param correlationId (optional) 
     * @param tracingId (optional) 
     * @param register (optional) 
     * @param finaliteiten (optional) 
     * @param operaties (optional) 
     * @param gebruikers (optional) 
     * @param startDatum (optional) 
     * @param eindDatum (optional) 
     * @param onderwerpen (optional) 
     * @param organisaties (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @return OK
     */
    consultaties_GetConsultaties(correlationId?: string | null | undefined, tracingId?: string | null | undefined, register?: string | null | undefined, finaliteiten?: string[] | null | undefined, operaties?: string[] | null | undefined, gebruikers?: string[] | null | undefined, startDatum?: string | null | undefined, eindDatum?: string | null | undefined, onderwerpen?: string[] | null | undefined, organisaties?: string[] | null | undefined, limit?: number | undefined, offset?: number | undefined): Promise<GetConsultatiesResponse>;
    /**
     * @return OK
     */
    consultaties_GetLijstenFinaliteiten(): Promise<GetLijstenFinaliteitenResponse>;
    /**
     * @return OK
     */
    consultaties_GetLijstenOperaties(): Promise<GetLijstenOperatiesResponse>;
    /**
     * @return OK
     */
    consultaties_GetLijstenRegisters(): Promise<GetLijstenRegistersResponse>;
    /**
     * @return OK
     */
    consultaties_GenerateAuditRapport(filters: ConsultatieFiltersDto): Promise<GenerateAuditRapportResponse>;
    /**
     * @return OK
     */
    consultaties_GetAuditRapport(auditRapportId: string): Promise<FileResponse>;
    /**
     * @return OK
     */
    registraties_SaveRegistratie(auditEvent: AuditEventDto): Promise<SaveRegistratieResponse>;
}

export class LogClient extends BffClientBase implements ILogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:48884";

    }

    /**
     * @param correlationId (optional) 
     * @param tracingId (optional) 
     * @param register (optional) 
     * @param finaliteiten (optional) 
     * @param operaties (optional) 
     * @param gebruikers (optional) 
     * @param startDatum (optional) 
     * @param eindDatum (optional) 
     * @param onderwerpen (optional) 
     * @param organisaties (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @return OK
     */
    consultaties_GetConsultaties(correlationId?: string | null | undefined, tracingId?: string | null | undefined, register?: string | null | undefined, finaliteiten?: string[] | null | undefined, operaties?: string[] | null | undefined, gebruikers?: string[] | null | undefined, startDatum?: string | null | undefined, eindDatum?: string | null | undefined, onderwerpen?: string[] | null | undefined, organisaties?: string[] | null | undefined, limit?: number | undefined, offset?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetConsultatiesResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "correlationId": correlationId !== undefined && correlationId !== null ? "" + correlationId : "",
                "tracingId": tracingId !== undefined && tracingId !== null ? "" + tracingId : "",
                "register": register !== undefined && register !== null ? "" + register : "",
                "finaliteiten": finaliteiten !== undefined && finaliteiten !== null ? "" + finaliteiten : "",
                "operaties": operaties !== undefined && operaties !== null ? "" + operaties : "",
                "gebruikers": gebruikers !== undefined && gebruikers !== null ? "" + gebruikers : "",
                "startDatum": startDatum !== undefined && startDatum !== null ? "" + startDatum : "",
                "eindDatum": eindDatum !== undefined && eindDatum !== null ? "" + eindDatum : "",
                "onderwerpen": onderwerpen !== undefined && onderwerpen !== null ? "" + onderwerpen : "",
                "organisaties": organisaties !== undefined && organisaties !== null ? "" + organisaties : "",
                "limit": limit !== undefined && limit !== null ? "" + limit : "",
                "offset": offset !== undefined && offset !== null ? "" + offset : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GetConsultaties(_response));
        });
    }

    protected processConsultaties_GetConsultaties(response: AxiosResponse): Promise<GetConsultatiesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetConsultatiesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConsultatiesResponse>(null as any);
    }

    /**
     * @return OK
     */
    consultaties_GetLijstenFinaliteiten(  cancelToken?: CancelToken | undefined): Promise<GetLijstenFinaliteitenResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties/lijsten/finaliteiten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GetLijstenFinaliteiten(_response));
        });
    }

    protected processConsultaties_GetLijstenFinaliteiten(response: AxiosResponse): Promise<GetLijstenFinaliteitenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetLijstenFinaliteitenResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLijstenFinaliteitenResponse>(null as any);
    }

    /**
     * @return OK
     */
    consultaties_GetLijstenOperaties(  cancelToken?: CancelToken | undefined): Promise<GetLijstenOperatiesResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties/lijsten/operaties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GetLijstenOperaties(_response));
        });
    }

    protected processConsultaties_GetLijstenOperaties(response: AxiosResponse): Promise<GetLijstenOperatiesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetLijstenOperatiesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLijstenOperatiesResponse>(null as any);
    }

    /**
     * @return OK
     */
    consultaties_GetLijstenRegisters(  cancelToken?: CancelToken | undefined): Promise<GetLijstenRegistersResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties/lijsten/registers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GetLijstenRegisters(_response));
        });
    }

    protected processConsultaties_GetLijstenRegisters(response: AxiosResponse): Promise<GetLijstenRegistersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetLijstenRegistersResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLijstenRegistersResponse>(null as any);
    }

    /**
     * @return OK
     */
    consultaties_GenerateAuditRapport(filters: ConsultatieFiltersDto , cancelToken?: CancelToken | undefined): Promise<GenerateAuditRapportResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties/rapporten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GenerateAuditRapport(_response));
        });
    }

    protected processConsultaties_GenerateAuditRapport(response: AxiosResponse): Promise<GenerateAuditRapportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GenerateAuditRapportResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateAuditRapportResponse>(null as any);
    }

    /**
     * @return OK
     */
    consultaties_GetAuditRapport(auditRapportId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/consultaties/rapporten/{auditRapportId}";
        if (auditRapportId === undefined || auditRapportId === null)
            throw new Error("The parameter 'auditRapportId' must be defined.");
        url_ = url_.replace("{auditRapportId}", encodeURIComponent("" + auditRapportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsultaties_GetAuditRapport(_response));
        });
    }

    protected processConsultaties_GetAuditRapport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    registraties_SaveRegistratie(auditEvent: AuditEventDto , cancelToken?: CancelToken | undefined): Promise<SaveRegistratieResponse> {
        let url_ = this.baseUrl + "/api/v1/legallog/registraties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auditEvent);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegistraties_SaveRegistratie(_response));
        });
    }

    protected processRegistraties_SaveRegistratie(response: AxiosResponse): Promise<SaveRegistratieResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SaveRegistratieResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRegistratieResponse>(null as any);
    }
}

export interface GetConsultatiesResponse {
    auditEvents?: AuditEventDto[];
    totalAmount?: number | undefined;
}

export interface AuditEventDto {
    meta?: MetaDto;
    registratie?: RegistratieDto;
    operatie?: OperatieDto;
    uitvoerder?: UitvoerderDto;
    onderwerpen?: OnderwerpDto[];
    informatie?: InformatieDto[];
    probleem?: ProbleemDto;
}

export interface MetaDto {
    onderwerpInOnderzoek?: boolean;
}

export interface RegistratieDto {
    correlatieId?: string;
    tracingId?: string;
    requestId?: string;
    clientId?: string;
}

export interface OperatieDto {
    operatie?: string;
    finaliteit?: FinaliteitDto;
    tijdstipUitvoering?: Date;
}

export interface FinaliteitDto {
    finaliteitId?: string;
    finaliteitType?: FinaliteitTypeEnum;
}

export enum FinaliteitTypeEnum {
    Beschrijving = "Beschrijving",
    IPDC = "IPDC",
}

export interface UitvoerderDto {
    gebruiker?: GebruikerDto;
    organisatie?: OrganisatieDto;
    dataverwerker?: DataverwerkerDto;
}

export interface GebruikerDto {
    gebruikerId?: string;
    gebruikerSleutelType?: GebruikerSleutelTypeEnum;
}

export enum GebruikerSleutelTypeEnum {
    Insz = "Insz",
    GebruikersIdentificatie = "GebruikersIdentificatie",
}

export interface OrganisatieDto {
    organisatieId?: string;
    organisatieSleutelType?: OrganisatieSleutelTypeEnum;
}

export enum OrganisatieSleutelTypeEnum {
    KboNummer = "KboNummer",
    OvoCode = "OvoCode",
    CommonName = "CommonName",
}

export interface DataverwerkerDto {
    dataverwerkerId?: string;
    dataverwerkerSleutelType?: DataverwerkerSleutelTypeEnum;
    dataverwerkerSysteem?: string;
}

export enum DataverwerkerSleutelTypeEnum {
    KboNummer = "KboNummer",
    OvoCode = "OvoCode",
    CommonName = "CommonName",
}

export interface OnderwerpDto {
    onderwerpId?: string;
    onderwerpSleutelType?: OnderwerpSleutelTypeEnum;
}

export enum OnderwerpSleutelTypeEnum {
    Insz = "Insz",
    PersoonsIdentificatie = "PersoonsIdentificatie",
    CapaKey = "CapaKey",
    Nrplaat = "Nrplaat",
    KboNummer = "KboNummer",
}

export interface InformatieDto {
    informatieWaarde?: string;
    informatieType?: string;
}

export interface ProbleemDto {
    type?: string;
    titel?: string;
    status?: string;
    detail?: string;
    instance?: string;
}

export interface ErrorMessage {
    type?: string | undefined;
    title: string;
    status?: number;
    detail: string;
    instance?: string | undefined;
}

export interface GetLijstenFinaliteitenResponse {
    finaliteiten?: string[];
}

export interface GetLijstenOperatiesResponse {
    operaties?: string[];
}

export interface GetLijstenRegistersResponse {
    registers?: string[];
}

export interface GenerateAuditRapportResponse {
    auditRapportId?: string;
}

export interface ConsultatieFiltersDto {
    register?: RegisterEnum;
    correlatieId?: string | undefined;
    tracingId?: string | undefined;
    operaties?: string[] | undefined;
    finaliteiten?: string[] | undefined;
    gebruikers?: string[] | undefined;
    startDatum?: Date | undefined;
    eindDatum?: Date | undefined;
    onderwerpen?: string[] | undefined;
    organisaties?: string[] | undefined;
}

export enum RegisterEnum {
    Vip = "Vip",
    Solid = "Solid",
    Magda = "Magda",
}

export interface SaveRegistratieResponse {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}